export const iconFontAwesomeFoodBeverageBottleWater = (
	<i className="fa-solid fa-bottle-water"></i>
);
